// extracted by mini-css-extract-plugin
module.exports = {"navHeight":"4.5rem","title":"profile_title__FKq0N"};